var map = {
	".": 2,
	"./": 2,
	"./App": 8,
	"./App.js": 8,
	"./CardView": 11,
	"./CardView.js": 11,
	"./Game": 9,
	"./Game.css": 10,
	"./Game.js": 9,
	"./Store.test": 19,
	"./Store.test.js": 19,
	"./actions": 1,
	"./actions.js": 1,
	"./cardFunctions": 5,
	"./cardFunctions.js": 5,
	"./images/1.jpg": 64,
	"./images/10.jpg": 65,
	"./images/2.jpg": 66,
	"./images/3.jpg": 67,
	"./images/4.jpg": 68,
	"./images/5.jpg": 69,
	"./images/6.jpg": 70,
	"./images/7.jpg": 71,
	"./images/8.jpg": 72,
	"./images/9.jpg": 73,
	"./images/back.jpg": 74,
	"./index": 2,
	"./index.css": 18,
	"./index.js": 2,
	"./reducers": 4,
	"./reducers.js": 4,
	"./registerServiceWorker": 14,
	"./registerServiceWorker.js": 14
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47;


//////////////////
// WEBPACK FOOTER
// ./src ^.*$
// module id = 47
// module chunks = 0